import { Fragment } from 'react';

import { Box, Stack } from '@mui/material';

import { WorkflowStepInstanceStatus } from 'src/@types/workflow/types';

import { RenderableRunStep } from './dashboardRun';
import DashboardWorkflowRunStepMarker from './DashboardWorkflowRunStepMarker';

const CONNECTOR_WIDTH = 16;
const UNREACHED_CONNECTOR_OPACITY = 0.25;

type DashboardWorkflowRunStepsProps = {
  steps: RenderableRunStep[];
};

export default function DashboardWorkflowRunSteps({ steps }: DashboardWorkflowRunStepsProps) {
  return (
    <Stack direction="row" sx={{ alignItems: 'center' }}>
      {steps.map(({ step, kind }, index) => (
        <Fragment key={step.stepInstanceId}>
          <DashboardWorkflowRunStepMarker step={step} kind={kind} />

          {index < steps.length - 1 && (
            <Box
              sx={{
                width: CONNECTOR_WIDTH,
                height: '2px',
                flexShrink: 0,
                bgcolor: 'primary.main',
                opacity:
                  step.status === WorkflowStepInstanceStatus.Completed
                    ? 1
                    : UNREACHED_CONNECTOR_OPACITY,
              }}
            />
          )}
        </Fragment>
      ))}
    </Stack>
  );
}
